import serverConnection from '../common/server-connection.js';

export default {
  data: {
    errorMessage: error_message? error_message: "",
    errorPopupStep: 0,
    messageId: 0,
    siteLang: site_lang,
  },
  mounted: function(){
    var that = this;
    if(that.errorMessage!==""){
      that.errorPopupStep = 1;
      that.messageId = 1;
      $('.error-popup').addClass('show');
      $('body').addClass('no-overflow');
    }
  },
  methods: {
    closeErrorPopup: function(){
      $('.error-popup').removeClass('show');
      $('body').removeClass('no-overflow');
    },
    redirectToLoginRegistration: function(){
        $('.error-popup').removeClass('show');
        $('body').removeClass('no-overflow');
        window.location.href = "/"+this.siteLang+"/users/sign_in";
    },
    goToMembership: function(){
      $('.error-popup').removeClass('show');
      $('body').removeClass('no-overflow');
      window.location.href = "/"+this.siteLang+"/user";
    },
    goToAddKid: function(){
      $('.error-popup').removeClass('show');
      $('body').removeClass('no-overflow');
      window.location.href = "/"+this.siteLang+"/user/kids/new";
    }
  }
}


// WEBPACK FOOTER //
// app/javascript/src/javascripts/components/error.mixin.js